import React, { Component } from 'react';
import Submit from '../component/Submit.js';
import Input from '../component/Input.js';
import SelectBox from '../component/Select.js';
import Modal from 'react-modal';
import magnify from '../asset/img/magnify.png';

export default class Gift extends Component{
	constructor(props){
		super(props);
		this.state = {
			prize: this.props.prize,
			quantity: 1,
			total: 0,
			available: 0,
			totalAvailable: 0,
			price: 0.00,
			variations: [],
			variationsIndex: {sizeIndex: 0, colorIndex: 0},
			size: 'N/A',
			color: 'N/A',
			photo: '',
			title: '',
			variantId: null,
			limit: null,
			button: true,
			modalIsOpen: false
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.getTotal = this.getTotal.bind(this);
		this.handleQuantity = this.handleQuantity.bind(this);
		this.handleColor = this.handleColor.bind(this);
		this.handleSize = this.handleSize.bind(this);
	}

	componentDidMount(){ //when component mounts, fill in appropriate information for each gift
		let allsizes = [];
		let variations = [];
		this.props.variants.forEach((variant)=>{
			allsizes.push(variant.size);
		});
		let sizes = allsizes.filter((v, i, a) => a.indexOf(v) === i);
		let firstcolor, firstphoto, firstsize, firstAvailableQuant, firstTotalAvailable, firstLimit;

		for( let i = 0; i < sizes.length; i++ ){ //outer for loop loops through each size in the array sizes
			variations.push({  //push objects to variations, colors array is for colors that correspond with each single size
				size: sizes[i],
				price: '',
				colors: [],
				photos: [],
				availableQuant: [],
				totalAvailable: [],
				variantId: [],
				limit: [],
				variantIds: []
			}); 
			for( let j = 0; j < this.props.variants.length; j++ ){ //loop through each variant to compare each size to variant

				if( sizes[i] === this.props.variants[j].size ){ //if the size matches the size in the variations array of objects, add the color to the colors array
					variations[i].colors.push(this.props.variants[j].color);
					variations[i].photos.push(this.props.variants[j].photo);
					variations[i].availableQuant.push(this.props.variants[j].quantity);
					variations[i].totalAvailable.push(this.props.variants[j].quantity);
					variations[i].price = this.props.variants[j].price;
					variations[i].limit.push( this.props.variants[j].limit ? this.props.variants[j].limit : Infinity ); //add this to new gf_keys
					variations[i].variantIds.push( this.props.variants[j].variantID ); //add this to new gf_keys
				}

			}
			if( sizes[i] === null || sizes[i] === undefined || sizes[i] === '' ){
				variations[i].size = "N/A";
			}
			if( variations[i].colors.length === 0 || variations[i].colors[0] === undefined || variations[i].colors[0] == null || variations[i].colors[0] === '' ){
				firstcolor = "N/A";
				firstphoto = variations[i].photos[0];
				firstsize = variations[i].size;
				firstAvailableQuant = variations[i].availableQuant[0];
				firstTotalAvailable = variations[i].totalAvailable[0];
				firstLimit = variations[i].limit[0];
			} else {
				firstcolor = variations[0].colors[0];
				firstphoto = variations[0].photos[0];
				firstAvailableQuant = variations[0].availableQuant[0];
				firstTotalAvailable = variations[i].totalAvailable[0];
				firstLimit = variations[0].limit[0];
			}
		}
		this.setState({
			title: this.props.prize,
			variations: variations,
			color: firstcolor,
			photo: firstphoto,
			price: variations[0].price,
			size: variations[0].size,
			available: firstAvailableQuant,
			totalAvailable: firstTotalAvailable,
			limit: firstLimit,
			quantity: (Number(firstAvailableQuant) > 0 ? 1 : 0)
		});
	}

	getTotal(x, y){
		return ( Number(x) * Number(y) );
	}

	handleQuantity(identity, value){ //method for handling user input for quantity of gift
		if( Number(this.state.available) > 0 ){ //only allow if gift inventory level is above 0
			const theState = {};
			if( /^(\s*|[1-9][0-9]*)$/.test(value) ){ //only allow positive integer values

				if( value !== '' ){

					if( Number(value) > Number(this.state.available) ){ //dont allow a quantity greater than the quantity available
						value = Number(this.state.available);
					}
					if( this.state.limit && Number.isFinite(this.state.limit) ){
						
						let cartQuant = this.props.cart.find(item => item.variantId === this.state.variantId);
						cartQuant = cartQuant ? cartQuant.quantity : 0;
						let totalQuant = cartQuant + value;
						let quantCheck = this.state.limit - totalQuant;
						console.log(cartQuant, quantCheck, this.state.limit)
						if( quantCheck < 0 ){
							value = this.state.limit - cartQuant;
						}
						
					}
					let total = this.getTotal(Number(this.state.price),value);

					while( this.props.currentBudget - total < 0 ){
						value--;
						total = this.getTotal(Number(this.state.price),value);
					}

					theState[identity] = Number(value);
				} else {
					theState[identity] = value;
				}
				this.setState(theState);
			}
		}
	}

	handleSize(identity,value){ //method that handles changing the size of a prize, and setting the correct first color and its respective picture
		let variants = this.state.variations;
		const theState = {};
		const variationsIndex = {};
		theState[identity] = value;

		for( let i = 0; i < variants.length; i++ ){

			if( variants[i].size === value ){
				theState['color'] = variants[i].colors[0]; //set first color of prize
				theState['photo'] = variants[i].photos[0]; //set picture for first color
				theState['available'] = variants[i].availableQuant[0];
				theState['totalAvailable'] = variants[i].totalAvailable[0];
				theState['limit'] = variants[i].limit[0];
				theState['variantId'] = variants[i].variantIds[0];
				theState['price'] = variants[i].price;
				variationsIndex['sizeIndex'] = i;
				variationsIndex['colorIndex'] = 0;
				theState['variationsIndex'] = variationsIndex;
				if( Number(theState['available']) > 0 ){
					theState['quantity'] = 1;
				} else {
					theState['quantity'] = 0;
				}
			}

		}
		this.setState(theState);
	}

	handleColor(identity,value){  //method for handling user input for colors, displays corresponding image of the color selected
		let variants = this.state.variations;
		const theState = {};
		const variationsIndex = {};
		theState[identity] = value;

		for( let i = 0; i < variants.length; i++ ){

			if ( variants[i].size === this.state.size ){

				for( let j = 0; j < variants[i].colors.length; j++ ){

					if( variants[i].colors[j] === value.replace(/\s/g,"_") ){
						theState['photo'] = variants[i].photos[j];
						theState['available'] = variants[i].availableQuant[j];
						theState['totalAvailable'] = variants[i].totalAvailable[j];
						variationsIndex['sizeIndex'] = i;
						variationsIndex['colorIndex'] = j;
						theState['variantId'] = variants[i].variantIds[j];
						theState['limit'] = variants[i].limit[j];
						theState['variationsIndex'] = variationsIndex;
						if( Number(theState['available']) > 0 ){
							theState['quantity'] = 1;
						} else {
							theState['quantity'] = 0;
						}
					}

				}

			}

		}
		this.setState(theState);
	}

	handleSubmit(){ //method for passing up gift information to be added to the shopping cart
		if( this.state.quantity !== '' ){
			let price = this.state.price;
			let quant = this.state.quantity === undefined || this.state.quantity === null || (this.state.quantity < 1) ? 1 : this.state.quantity;
			let available = Number(this.state.available) - Number(quant);
			let total = this.getTotal(price,quant).toFixed(2); //get total cost based on quantity and unit price
			let cartQuant = this.props.cart.find(item => item.variantId === this.state.variantId);
			cartQuant = cartQuant ? cartQuant.quantity : 0;
			let totalQuant = cartQuant + quant;
			let canAdd = ( (totalQuant <= this.state.limit) && (available >= 0) && (this.props.currentBudget - total >= 0) );

			if( canAdd ){

				let variations = [...this.state.variations];
				let oldVariantQuantity = variations[this.state.variationsIndex.sizeIndex].availableQuant;
				let newVariantQuantity = [...oldVariantQuantity];
				newVariantQuantity[this.state.variationsIndex.colorIndex] = available;
				variations[this.state.variationsIndex.sizeIndex].availableQuant = newVariantQuantity;

				this.setState({
					total: total,
					available: available,
					button: false,
					variations: variations
				}, function(){ //on click, add button displays "Added!" for half a second
						setTimeout(()=>{
							this.setState({ button: true });
						}, 500);
						let lineItem = {
							prize: this.state.prize,
							quantity: Number(quant),
							total: this.state.total,
							size: this.state.size,
							color: this.state.color,
							variationsIndex: this.state.variationsIndex,
							totalAvailable: this.state.totalAvailable,
							limit: this.state.limit,
							variantId: this.state.variantId
						};
						this.props.onChoice(lineItem); //pass up gift information

						if( available > 0 && totalQuant < this.state.limit ){
							this.setState({ quantity: 1 });
						} else {
							this.setState({ quantity: 0 });
						}
					}
				);

			}

		}
	}

	componentDidUpdate(prevProps){ //update available quantity of gift, which is passed down from giftshop. can change if quantity in shopping cart is edited
		if( prevProps.didCartChange !== this.props.didCartChange && this.props.cartChangeGift.prize === this.props.prize ){
			let cartChangeGift = this.props.cartChangeGift;
			let allsizes = [];
			let variations = [];
			let currentAvailable = Number(this.state.available);
			let totalAvailable = Number(this.state.totalAvailable);
			let quantity = 1;
			this.props.variants.forEach((variant)=>{
				allsizes.push(variant.size);
			});
			let sizes = allsizes.filter((v, i, a) => a.indexOf(v) === i);

			for( let i = 0; i < sizes.length; i++ ){ //outer for loop loops through each size in the array sizes
				variations.push({  //push objects to variations, colors array is for colors that correspond with each single size
					size: sizes[i],
					price: '',
					colors: [],
					photos: [],
					availableQuant: [],
					totalAvailable: [],
					limit: [],
					variantIds: []
				}); 
				for( let j = 0; j < this.props.variants.length; j++ ){ //loop through each variant to compare each size to variant

					if( sizes[i] === this.props.variants[j].size ){ //if the size matches the size in the variations array of objects, add the color to the colors array
						variations[i].colors.push(this.props.variants[j].color);
						variations[i].photos.push(this.props.variants[j].photo);
						variations[i].availableQuant.push(this.props.variants[j].currentQuantity);
						variations[i].totalAvailable.push(this.props.variants[j].quantity);
						variations[i].price = this.props.variants[j].price;
						variations[i].limit.push( this.props.variants[j].limit ? this.props.variants[j].limit : Infinity );
						variations[i].variantIds.push( this.props.variants[j].variantID );
					}

				}
				if( sizes[i] === null || sizes[i] === undefined || sizes[i] === '' ){
					variations[i].size = "N/A";
				}
				if ( variations[i].size === this.state.size && i == cartChangeGift.sizeIndex){
					let changedColor = variations[cartChangeGift.sizeIndex].colors[cartChangeGift.colorIndex];
					let _index = variations[i].colors.indexOf(changedColor);
					if( _index !== -1 ){
						currentAvailable = Number(variations[i].availableQuant[_index]);
						totalAvailable = Number(variations[i].totalAvailable[_index]);
					}
				}
			}

			if( currentAvailable < 1 ){
				quantity = 0;
				currentAvailable = 0;
			}

			this.setState({ 
				available: currentAvailable,
				totalAvailable: totalAvailable,
				quantity: quantity,
				variations: variations
			});
		}
	}

	render(){
		const customStyles = {
		  	content : {
			    top: '50%',
			    left: '50%',
			    right: 'auto',
			    bottom: 'auto',
			    width:'100%',
			    maxWidth:'600px',
			    padding:'5px',
			    transform: 'translate(-50%, -50%)',
			    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		const magnifyButton = {
			backgroundImage: 'url('+magnify+')',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundColor: 'white',
			backgroundSize: '25px 25px',
			minWidth: '30px',
			minHeight:'30px',
			maxWidth: '30px',
			maxHeight: '30px',
			borderRadius:'8px'
		};
		const picstyles = {
			display:'block',
			maxWidth:'100px',
			maxHeight:'122px',
			width:'auto',
			height:'auto',
			margin:'auto',
			cursor: 'pointer'
		};
		const modalPicStyles = {
			display:'block',
			width:'auto',
			height:'auto',
			margin:'auto',
			boxShadow:'1px 1px 4px 4px #aaaaaa'
		};//border:'1px solid black'};
		const minHeightStyle = { minHeight:'38px' };
		const selectStyle = "w-60 mv1 ml1 mr1 pa1 shadow-2 br2 b--gray bw1";
		const labelDivStyle = "fl w-50 mt2 b gray";
		const selectDivStyle = "fl w-50 tl";
		const borderstyle = "br3 bg-white";
		let thePrice = this.state.price.toFixed(2);
		let disable = Number(this.state.available) > 0?false:true;
		let availableStyle = Number(this.state.available) > 0?"mt2 ml1 tl b mb2":"mt2 ml1 tl b mb2 red";
		let descriptionArray = this.props.description.split(",");
		let bulletPoints = descriptionArray.map((details,i)=>{
			return <li className="pb3" key={i}>{details}</li>;
		});
		let theButton = <Submit name="Add" onClick={this.handleSubmit} styles="bg-dark-blue white grow b br3 bn shadow-3 h2 w-20-ns" disable={disable}/>;
		if( !this.state.button ){ //message displayed in place of add button, on click, for half a second
			theButton = <div className="pt3"><p className="tc mb0 pt4 pb0"><span className="mt4 b navy">Added!</span></p></div>;
		}

		let size=[];
		let colors =[];
		let theColors = [];
		const vari = this.state.variations;
		vari.forEach((variation)=>{
			size.push(variation.size);
		});
		let selectSize;
		let selectColor;
		if( size[0] === "N/A" ){ //if there are no size options, only display color options
			selectSize = <p className="b mt1 mb1 pt1 pb2">N/A</p>;
			colors = this.state.variations[0].colors;
			colors.forEach((color)=>{
				if( color === null || color === undefined || color === '' ){
					color = "N/A";
				} else {
					color = color.replace(/_/g," ");
				}
				theColors.push(color);
			});
			if( colors.length === 1 && colors[0] === "N/A" ){
				selectColor = <p className="b mt1 mb1 pt1 pb2">N/A</p>;
			} else {
				selectColor = <SelectBox
								name="color"
								identity="color"
								onSelect={this.handleColor}
								options={theColors}
								styles={selectStyle}
								val={this.state.color}
							   />;
			}
		} else { //if there are color options, consolidate them based on the selected size
			selectSize = <SelectBox
							name="size"
							identity="size"
							onSelect={this.handleSize}
							options={size}
							styles={selectStyle}
							val={this.state.size}
						  />;
				vari.forEach((variant)=>{
					if( variant.size === this.state.size ){
						colors = variant.colors;
						colors.forEach((color)=>{
							if( color === null|| color === undefined || color === '' ){
								color = "N/A";
							} else {
								theColors.push(color.replace(/_/g," "));
							}
						});
					}
				});
				if( colors.length === 1 && colors[0] === "N/A" ){
					selectColor = <p className="b mt1 mb1 pt1 pb2">N/A</p>;
				} else {
					selectColor = <SelectBox
									name="color"
									identity="color"
									onSelect={this.handleColor}
									options={theColors}
									styles={selectStyle}
									val={this.state.color}
								  />;
				}	
		}
		if( this.state.color === "N/A" && this.state.size === "N/A" ){
			selectColor = <p className="b mt1 mb1 pt1 pb2">N/A</p>;
		}
		let imgpath = this.props.path + this.state.photo;
		imgpath = imgpath.replace(/\s/g,"_");
		return(
			<div className={borderstyle} style={{minWidth:'260px',minHeight:'420px',boxShadow:'1px 1px 4px 4px #aaaaaa',maxWidth:'315px',margin:'auto'}}>
				<div className="tc" style={{height: '176px'}}>
					<div className="fl w-100">
						<p className="mt0 pt2 b navy fl tc w-20-ns"></p>
						<p className="mt0 pt2 b navy tc fl w-60-ns">{this.props.prize} </p>
						<p className="mt0 pt2 b navy fl tc w-20-ns">$<span className="dark-red">{thePrice} </span></p>
					</div>
					<img src={imgpath} alt={this.props.prize} style={picstyles} onClick={()=>{this.setState({modalIsOpen:true})}}/>
				</div>
				<div className="fl cf w-100 mb2 pb mt2 ml4 tl">
					{/* <div className="fl w-100 center">
						<div className={labelDivStyle}>
							<label>View Details</label>
						</div>
						<div className={selectDivStyle}>
							<button style={magnifyButton} className="ml1 pointer" onClick={()=>{this.setState({modalIsOpen:true})}}></button>
						</div>
					</div> */}
					<div className="fl w-100 center">
						<div className={labelDivStyle}>
							<label>Limit: </label>
						</div>
						<div className={selectDivStyle}>
							<p className={availableStyle}>{this.state.limit && Number.isFinite(this.state.limit) ? this.state.limit : 'N/A'}</p>
						</div>
					</div>
					<div className="w-100 center mt2">
						<div className={labelDivStyle}>
							<label>Available: </label>
						</div>
						<div className="fl w-50 tc">
							<p className={availableStyle}>{this.state.available}</p>
						</div>
					</div>
					<div className="w-100  center">
						<div className={labelDivStyle}>
							<label>Size:</label>
						</div>
						<div className={selectDivStyle} style={minHeightStyle}>
							{selectSize}
						</div>
					</div>
					<div className="w-100  center">
						<div className={labelDivStyle}>
							<label>Color:</label>
						</div>
						<div className={selectDivStyle}>
							{selectColor}
						</div>
					</div>
					<div className="w-100  center">
						<div className={labelDivStyle}>
							<label>Quantity:</label>
						</div>
						<div className={selectDivStyle}>
							<Input name="quantity" identity="quantity" onInput={this.handleQuantity} val={this.state.quantity} type="number" inputStyle={selectStyle}/>
						</div>
					</div>
				</div>
				<div className="mv3 pt3">
					{theButton}
				</div>
				<div>
					<Modal
			          isOpen={this.state.modalIsOpen}
			          style={customStyles}
			          contentLabel="shopping cart Modal"
			          shouldCloseOnOverlayClick={true}
			          shouldCloseOnEsc={false}
			        >
			        <div className="fl w-100 tr pt0 pr0 pb1">
				    	<label className="b gray" onClick={()=>{this.setState({modalIsOpen:false})}}>X</label>
				    </div>
			      	<div className="fl w-100 pb3 pl3 pr3">
			      	<div className="fl w-40">
			      		<ul style={{paddingLeft:'10px',paddingRight:'30px'}}>
			      			{bulletPoints}
			      		</ul>
			      	</div>
			      	<div className="fl w-60">
			      		<img src={imgpath} alt={this.props.prize} style={modalPicStyles}/>
			      	</div>
			      </div>
			    </Modal>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/Gift.js